import React, { Dispatch, FC, SetStateAction } from 'react';
import { Button, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { colors } from 'common/ui/theme/default';
import unMessages from 'common/messages/userNotifications';
import useUserNotificationsContext from 'common/hooks/context/useUserNotificationsContext';

const useStyles = makeStyles((theme: Theme) => ({
  subheader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  btnGroup: {
    display: 'flex',
    gap: '2px',
    backgroundColor: colors.lightGray,
    padding: '2px',
    borderRadius: '4px',
  },
  btnGroupItem: {
    width: '80px',
    borderRadius: '4px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'initial',
    },
  },
  btnGroupItemActive: {
    cursor: 'default',
    pointerEvents: 'none',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
  },
  btnNoEvents: {
    pointerEvents: 'none',
  },
  btnMarkAll: {
    padding: '0',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'initial',
      boxShadow: 'unset',
    },
  },
}));

interface IUserNotificationsSubheader {
  groupStatus: 'all' | 'unread';
  setGroupStatus: Dispatch<SetStateAction<'all' | 'unread'>>;
  hasUnreadNotification: boolean;
  userNotificationsLoading: boolean;
}

const UserNotificationsSubheader: FC<IUserNotificationsSubheader> = ({
  groupStatus,
  setGroupStatus,
  hasUnreadNotification,
  userNotificationsLoading: unsLoading,
}) => {
  const {
    readUserNotifications,
    readUserNotificationsLoading: readUNsLoading,
  } = useUserNotificationsContext();

  const classes = useStyles();
  const intl = useIntl();

  return (
    <div className={classes.subheader}>
      <div className={classes.btnGroup}>
        <Button
          className={classNames(classes.btnGroupItem, {
            [classes.btnGroupItemActive]: groupStatus === 'unread',
            [classes.btnNoEvents]: unsLoading,
          })}
          onClick={() => setGroupStatus('unread')}
        >
          {intl.formatMessage(unMessages.userNotificationsBtnGroupItemUnread)}
        </Button>

        <Button
          className={classNames(classes.btnGroupItem, {
            [classes.btnGroupItemActive]: groupStatus === 'all',
            [classes.btnNoEvents]: unsLoading,
          })}
          onClick={() => setGroupStatus('all')}
        >
          {intl.formatMessage(unMessages.userNotificationsBtnGroupItemAll)}
        </Button>
      </div>

      <Button
        className={classNames(classes.btnMarkAll, {
          [classes.btnNoEvents]: unsLoading || readUNsLoading,
        })}
        disabled={!hasUnreadNotification}
        onClick={readUserNotifications}
      >
        {intl.formatMessage(unMessages.userNotificationsMarkAllAsRead)}
      </Button>
    </div>
  );
};

export default UserNotificationsSubheader;
